/* miPADDLE cart rewards: progress bar + free gift picker.
   Thresholds come from data attributes rendered by snippets/cart-rewards.liquid.
   Gift lines are tagged with the hidden line property _reward_gift and never count toward thresholds.
   Gift cards never count toward thresholds. */
(function () {
  'use strict';
  if (window.__miRewardsLoaded) return;
  window.__miRewardsLoaded = true;

  var GIFT_PROP = '_reward_gift';
  var selfRequest = 0;
  var refreshTimer = null;
  var lastCart = null;

  function roots() { return document.querySelectorAll('[data-mi-rewards]'); }
  function giftBoxes() { return document.querySelectorAll('[data-mi-gifts]'); }

  function thresholds() {
    var el = document.querySelector('[data-mi-rewards]');
    return {
      ship: el ? parseInt(el.getAttribute('data-ship'), 10) : 9900,
      gift: el ? parseInt(el.getAttribute('data-gift'), 10) : 20000
    };
  }

  function money(cents) {
    var d = cents / 100;
    return '$' + (cents % 100 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  function isGiftLine(item) {
    return item.properties && item.properties[GIFT_PROP];
  }

  function eligibleTotal(cart) {
    return cart.items.reduce(function (sum, item) {
      if (item.gift_card || isGiftLine(item)) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  function giftLines(cart) {
    return cart.items.filter(isGiftLine);
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function cartRequest(path, body) {
    selfRequest++;
    return fetch(path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Mi-Rewards': '1' },
      body: JSON.stringify(body)
    }).then(function (r) {
      selfRequest--;
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }, function (err) { selfRequest--; throw err; });
  }

  /* ---------- rendering ---------- */

  function render(cart) {
    var t = thresholds();
    var total = eligibleTotal(cart);
    var gifts = giftLines(cart);
    var hasGift = gifts.length > 0;
    var empty = cart.item_count === 0;
    var msg;

    if (total < t.ship) {
      msg = 'You’re <strong>' + money(t.ship - total) + '</strong> away from <strong>free shipping</strong>';
    } else if (total < t.gift) {
      msg = 'Free shipping unlocked! <strong>' + money(t.gift - total) + '</strong> away from a <strong>free gift</strong>';
    } else if (!hasGift) {
      msg = 'You’ve unlocked a <strong>free gift</strong> — pick one below!';
    } else {
      msg = 'Free shipping + free gift unlocked!';
    }

    var pct = Math.min(total / t.gift, 1) * 100;

    Array.prototype.forEach.call(roots(), function (root) {
      root.hidden = empty;
      var m = root.querySelector('[data-mi-msg]');
      if (m) m.innerHTML = msg;
      var f = root.querySelector('[data-mi-fill]');
      if (f) f.style.width = pct + '%';
      var ship = root.querySelector('[data-mi-node="ship"]');
      var gift = root.querySelector('[data-mi-node="gift"]');
      if (ship) ship.classList.toggle('is-done', total >= t.ship);
      if (gift) gift.classList.toggle('is-done', total >= t.gift);
    });

    var unlocked = total >= t.gift;
    Array.prototype.forEach.call(giftBoxes(), function (box) {
      box.hidden = empty;
      box.classList.toggle('is-unlocked', unlocked);
      box.classList.toggle('is-claimed', hasGift);
      var title = box.querySelector('[data-mi-gifts-title]');
      var badge = box.querySelector('[data-mi-gifts-badge]');
      if (title) {
        title.textContent = hasGift ? 'Free gift added' : (unlocked ? 'Claim your free gift!' : 'Free hat, cover or tote at ' + money(t.gift));
      }
      if (badge) badge.hidden = !(unlocked && !hasGift);
      var giftVariant = hasGift ? String(gifts[0].variant_id) : null;
      Array.prototype.forEach.call(box.querySelectorAll('[data-mi-gift]'), function (row) {
        var btn = row.querySelector('[data-mi-gift-add]');
        var status = row.querySelector('[data-mi-gift-status]');
        var isThis = giftVariant === row.getAttribute('data-variant-id');
        row.classList.toggle('is-selected', isThis);
        if (btn) {
          btn.disabled = !unlocked || hasGift;
          btn.textContent = isThis ? 'ADDED' : 'ADD';
        }
        if (status) {
          status.textContent = isThis ? 'In your cart' : (unlocked ? 'Free gift unlocked' : 'Unlocks at ' + money(t.gift));
        }
      });
    });
  }

  /* ---------- rules: gift only above threshold, max one ---------- */

  function enforce(cart) {
    var t = thresholds();
    var total = eligibleTotal(cart);
    var gifts = giftLines(cart);
    var fixes = [];

    if (gifts.length && total < t.gift) {
      gifts.forEach(function (g) { fixes.push({ id: g.key, quantity: 0 }); });
    } else if (gifts.length) {
      gifts.forEach(function (g, i) {
        if (i === 0 && g.quantity > 1) fixes.push({ id: g.key, quantity: 1 });
        if (i > 0) fixes.push({ id: g.key, quantity: 0 });
      });
    }

    if (!fixes.length) return Promise.resolve(false);
    return fixes.reduce(function (p, fix) {
      return p.then(function () { return cartRequest('/cart/change.js', fix); });
    }, Promise.resolve()).then(function () { return true; });
  }

  /* ---------- keep theme cart UI in sync after our own changes ---------- */

  function rebuildThemeCart(cart) {
    if (document.getElementById('CartPageForm')) {
      window.location.reload();
      return;
    }
    // Impulse listens for this to rebuild the drawer.
    document.dispatchEvent(new CustomEvent('cart:build'));
    // Fallback: re-render the drawer items ourselves.
    var drawerProducts = document.querySelector('#CartDrawer [data-products]');
    if (!drawerProducts) return;
    fetch('/cart?view=ajax', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var items = tmp.querySelector('.cart__items');
        if (items) drawerProducts.innerHTML = items.outerHTML;
        var subtotal = document.querySelector('#CartDrawer [data-subtotal]');
        if (subtotal) subtotal.textContent = '$' + (cart.total_price / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        Array.prototype.forEach.call(document.querySelectorAll('.cart-link__bubble'), function (b) {
          b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        });
      });
  }

  function refresh() {
    return getCart().then(function (cart) {
      return enforce(cart).then(function (changed) {
        if (!changed) { lastCart = cart; render(cart); return; }
        return getCart().then(function (fresh) {
          lastCart = fresh;
          render(fresh);
          rebuildThemeCart(fresh);
        });
      });
    }).catch(function () {});
  }

  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, delay || 350);
  }

  /* ---------- add gift ---------- */

  function addGift(variantId, btn) {
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    var props = {};
    props[GIFT_PROP] = 'Free gift';
    cartRequest('/cart/add.js', { items: [{ id: parseInt(variantId, 10), quantity: 1, properties: props }] })
      .then(getCart)
      .then(function (cart) {
        lastCart = cart;
        render(cart);
        rebuildThemeCart(cart);
      })
      .catch(function () {
        if (btn) { btn.textContent = 'ADD'; btn.disabled = false; }
        scheduleRefresh(0);
      });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-mi-gift-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      var row = add.closest('[data-mi-gift]');
      if (row) addGift(row.getAttribute('data-variant-id'), add);
      return;
    }
    var toggle = e.target.closest && e.target.closest('[data-mi-gifts-toggle]');
    if (toggle) {
      e.preventDefault();
      var box = toggle.closest('[data-mi-gifts]');
      var collapsed = box.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    }
  });

  /* ---------- watch the theme's own cart requests ---------- */

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?/.test(String(url || ''));
  }

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var mine = init && init.headers && (init.headers['X-Mi-Rewards'] || (init.headers.get && init.headers.get('X-Mi-Rewards')));
      var p = origFetch.apply(this, arguments);
      if (!mine && isCartMutation(url)) {
        p.then(function () { scheduleRefresh(); }, function () {});
      }
      return p;
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url)) {
      this.addEventListener('loadend', function () { scheduleRefresh(); });
    }
    return origOpen.apply(this, arguments);
  };

  document.addEventListener('ajaxProduct:added', function () { scheduleRefresh(); });
  document.addEventListener('cart:updated', function () { scheduleRefresh(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(); });
  } else {
    refresh();
  }
})();
